// extracted by mini-css-extract-plugin
export default {"card":"styles_card__YVVkV","label":"styles_label__cMu+z","text":"styles_text__0ahSC","link":"styles_link__mzfP6"};